import { render } from "./FactoryShow.vue?vue&type=template&id=61a65a94&scoped=true&bindings={}"
import script from "./FactoryShow.vue?vue&type=script&lang=ts"
export * from "./FactoryShow.vue?vue&type=script&lang=ts"

import "./FactoryShow.vue?vue&type=style&index=0&id=61a65a94&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-61a65a94"

export default script